// @ts-check

import createStripeWalletStrategy from '../../../utils/createStripeWalletPayload';

/**
 * @typedef {import('../../../utils/createStripeWalletPayload').StripeWalletStrategy} StripeGooglePayStrategy
 */

/**
 * Stripe Google Pay strategy.
 * Thin wrapper over the shared Stripe wallet builder, parameterized with the `google_pay_data`
 * nested key. See `createStripeWalletStrategy` for the payload contract.
 * @type {import('../../../utils/createStripeWalletPayload').StripeWalletStrategy}
 */
const stripeGooglePayStrategy = createStripeWalletStrategy({ walletDataKey: 'google_pay_data' });

export default stripeGooglePayStrategy;
